module.exports = __webpack_public_path__ + "static/media/illustrationCc.677dcab0.png";